import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * LEGACY: Allowed template identifiers. THIS REFERS TO OLD TOOKAN TEMPLATES AND SHOULD BE REMOVED FROM PROD DATA.
 */
export const schema = z.array(z.string());

export type AllowedTemplates = z.infer<typeof schema>;

export const definition = define({
  key: 'allowed_templates',
  schema,
  label: 'Allowed Templates',
  description: 'LEGACY - Allowed template identifiers. Restricts which move templates this customer can use.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.MOVE_PLANNING.key,
  writableAtLevels: [LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  deprecated: true,
});
